import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  CodeSlash,
  Database,
  Cloud,
  Wrench,
  Server
} from "react-bootstrap-icons";

import "./skills.css";

const skills = [

{
title:"Backend & APIs",
icon:<CodeSlash/>,
items:[
"Node.js",
"Express.js",
"RESTful APIs",
"GraphQL",
"PHP",
"OpenAI Integration"
]
},

{
title:"Frontend",
icon:<CodeSlash/>,
items:[
"React.js",
"React Hooks",
"TypeScript",
"HTML/CSS",
"Responsive Design",
"UI/UX"
]
},

{
title:"Database & Storage",
icon:<Database/>,
items:[
"MySQL",
"PostgreSQL",
"MongoDB",
"Redis",
"AWS S3",
"RabbitMQ"
]
},
{
title:"Web Services & APIs",
icon:<CodeSlash/>,
items:[
"REST",
"XML",
"CMS Design",
"API Handling"
]
},
{
title:"DevOps & CI/CD",
icon:<Cloud/>,
items:[
"Docker",
"Kubernetes",
"Jenkins",
"Bitbucket",
"SonarQube",
"JIRA"
]
},

{
title:"Cloud & Infrastructure",
icon:<Server/>,
items:[
"AWS",
"EC2",
"Lambda",
"RDS",
"DigitalOcean",
"Azure"
]
},

{
title:"Tools & Platforms",
icon:<Wrench/>,
items:[
"Git",
"GitHub",
"FFMPEG",
"Linux",
"Nginx",
"Apache"
]
},

{
title:"Operating Systems",
icon:<Server/>,
items:[
"Linux",
"Windows"
]
},

{
title:"Other Expertise",
icon:<CodeSlash/>,
items:[
"System Architecture",
"Project Management",
"Mentoring",
"Server Configuration"
]
}

];

const Skills=()=>(
<section id="skills">

<Container>

<h2>Skills & Expertise</h2>

<Row>

{skills.map((skill,index)=>(

<Col lg={4} md={6} className="mb-4" key={index}>

<div className="skill-card">

<div className="skill-title">

{skill.icon}

<span>{skill.title}</span>

</div>

<div>

{skill.items.map((item,i)=>

<span key={i} className="tech-badge">

{item}

</span>

)}

</div>

</div>

</Col>

))}

</Row>

</Container>

</section>
);

export default Skills;